/**
 * Ödül Öneri — yönetici çözümü yalnızca “ilgili bölüm” + tesis üzerinden.
 * Çalıştığı birim (employeeDept) burada ASLA kullanılmaz; o birime mail/token gitmez.
 */
import {
  resolveDepartmentFacility,
  DEFAULT_DEPARTMENT_FACILITY,
} from './odulOneriFacilities'

const normalizeDeptKey = (value) =>
  String(value || '')
    .trim()
    .toLocaleLowerCase('tr')

/**
 * @param {{
 *   relatedDepartmentId?: string,
 *   relatedDepartmentName?: string,
 *   facility?: string,
 *   location?: string,
 * }} related
 * @param {Array<{ id: string, name: string, facility?: string, managerName?: string, managerEmail?: string, active?: boolean }>} departments
 * @returns {{ id: string, name: string, facility: string, managerName: string, managerEmail: string }}
 */
export const resolveRelatedDepartmentManager = (related, departments = []) => {
  const relatedId = String(related?.relatedDepartmentId || '').trim()
  const relatedName = String(related?.relatedDepartmentName || '').trim()
  const facility = resolveDepartmentFacility(
    related?.facility || related?.location || DEFAULT_DEPARTMENT_FACILITY
  )

  if (!relatedId && !relatedName) {
    throw new Error('Önerinin ilgili olduğu bölüm seçilmelidir.')
  }

  const list = (departments || [])
    .filter((dept) => dept && dept.active !== false)
    .filter((dept) => resolveDepartmentFacility(dept.facility) === facility)

  let matched =
    (relatedId && list.find((dept) => String(dept.id) === relatedId)) ||
    (relatedName &&
      list.find((dept) => normalizeDeptKey(dept.name) === normalizeDeptKey(relatedName))) ||
    null

  // id ile isim çelişirse aynı tesis içinde isme güven (form seçimi)
  if (matched && relatedName) {
    const nameMatch = list.find(
      (dept) => normalizeDeptKey(dept.name) === normalizeDeptKey(relatedName)
    )
    if (nameMatch && nameMatch.id !== matched.id) {
      matched = nameMatch
    }
  }

  if (!matched) {
    throw new Error(
      `İlgili bölüm bulunamadı: “${relatedName || relatedId}” (${facility}). Öneri Süreci Ayarları’ndan bu tesis için kontrol edin.`
    )
  }

  const managerEmail = String(matched.managerEmail || '')
    .trim()
    .toLowerCase()
  const managerName = String(matched.managerName || '').trim()

  if (!managerEmail || !managerEmail.includes('@')) {
    throw new Error(
      `“${matched.name}” (${facility}) birimi için yönetici e-postası tanımlı değil. Onay maili gönderilemez.`
    )
  }

  return {
    id: matched.id,
    name: matched.name,
    facility,
    managerName: managerName || matched.name,
    managerEmail,
  }
}

/**
 * Form önizleme — hata fırlatmadan.
 * @returns {{ ok: boolean, manager?: object, error?: string }}
 */
export const previewRelatedDepartmentManager = (related, departments = []) => {
  try {
    const manager = resolveRelatedDepartmentManager(related, departments)
    return { ok: true, manager }
  } catch (error) {
    return { ok: false, error: error?.message || 'İlgili bölüm yöneticisi çözülemedi.' }
  }
}
